"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("@powerednow/shared/constants");
const momentOverride_1 = __importDefault(require("@powerednow/shared/modules/utilities/momentOverride"));
const bluebird_1 = __importDefault(require("bluebird"));
const Renderer_1 = __importDefault(require("../../classes/Renderer"));
class DocumentRenderData extends Renderer_1.default {
    async getQuotePrompt() {
        const code = 'Document.TypeQuote';
        const defaultVal = 'Qte';
        const company = await this.item.getCompany();
        const quoteNameId = company.data.quote_name_id > 0 ? company.data.quote_name_id : 1;
        if (quoteNameId === 2) {
            // Estimate
            return this.L(`${code}_est`, defaultVal);
        }
        return this.L(code, defaultVal);
    }
    getTypeString() {
        const docTypes = constants_1.DOCUMENT.TYPES;
        if (docTypes[this.item.data.type]) {
            return docTypes[this.item.data.type];
        }
        console.log('Error! Document type not found!', this.item.data.type);
        return '';
    }
    async getShortTypeString() {
        const typeStringMap = {
            [constants_1.DOCUMENT.TYPES_VALUES.INVOICE]: () => this.L('Document.TypeInvoiceShort', 'Inv'),
            [constants_1.DOCUMENT.TYPES_VALUES.QUOTE]: () => this.getQuotePrompt(),
            [constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET]: () => this.L('Document.TypeWorksheetShort', 'Ws'),
            [constants_1.DOCUMENT.TYPES_VALUES.CREDITNOTE]: () => this.L('Document.TypeCreditnoteShort', 'Cr'),
            [constants_1.DOCUMENT.TYPES_VALUES.SIGNATURE]: () => this.L('Document.TypeSignatureShort', 'Sign'),
            [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE]: () => this.L('Document.TypeSupplierInvoiceShort', 'Sup'),
            [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT]: () => this.L('Document.TypeSupplierInvoiceCreditShort', 'Sup Cr'),
            [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE]: () => this.L('Document.TypeExpenseShort', 'Exp'),
            [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE]: () => this.L('Document.TypeExpenseCreditNoteShort', 'Exp Cr'),
            [constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER]: () => this.L('Document.TypePurchaseOrderShort', 'Po'),
        };
        if (typeStringMap[this.item.data.type]) {
            return typeStringMap[this.item.data.type]();
        }
        return '';
    }
    async getCustomerTitle() {
        const customer = await this.L('DocumentView.CustomerDetails', 'Customer Details');
        const supplier = await this.L('DocumentView.SupplierTitle', 'Supplier Details');
        const typeCustomerTitleMap = {
            [constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER]: supplier,
            [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE]: supplier,
            [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT]: supplier,
            [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE]: '',
            [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE]: '',
        };
        if (typeCustomerTitleMap[this.item.data.type] !== undefined) {
            return typeCustomerTitleMap[this.item.data.type];
        }
        return customer;
    }
    shallShowAccountName(isSupplier, accountName) {
        const isPurchaseOrder = this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER;
        return isPurchaseOrder && Boolean(isSupplier && accountName && accountName.trim().length);
    }
    async getDocBodyPaddingStyle(doctype) {
        // getCompanySettings param changed to false to not leave envelop_settings field empty - caused template overlapping
        const company = await this.item.getCompany();
        const envelopeSettings = await company.getEnvelopeTypeSettings();
        if (envelopeSettings) {
            let topOffset_px = envelopeSettings.windowTopOffset * constants_1.ENVELOPE_TYPE.MM_TO_PX;
            if (topOffset_px < 0)
                topOffset_px = 0;
            if (doctype === constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE) {
                topOffset_px /= 2;
            }
            let leftOffset_px = envelopeSettings.windowLeftOffset * constants_1.ENVELOPE_TYPE.MM_TO_PX;
            if (leftOffset_px < 0)
                leftOffset_px = 0;
            return `padding-top: ${topOffset_px}px; padding-left: ${leftOffset_px}px;`;
        }
        return '';
    }
    async getDisplayTypeString() {
        const typeStringMap = {
            [constants_1.DOCUMENT.TYPES_VALUES.INVOICE]: () => this.L('Document.TypeInvoice', 'Invoice'),
            [constants_1.DOCUMENT.TYPES_VALUES.QUOTE]: () => this.getQuotePrompt(),
            [constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET]: () => this.L('Document.TypeWorksheet', 'Job Sheet'),
            [constants_1.DOCUMENT.TYPES_VALUES.CREDITNOTE]: () => this.L('Document.TypeCreditnote', 'Credit Note'),
            [constants_1.DOCUMENT.TYPES_VALUES.SIGNATURE]: () => this.L('Document.TypeSignature', 'Signature'),
            [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE]: () => this.L('Document.TypeSupplierInvoice', 'Supplier Invoice'),
            [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT]: () => this.L('Document.TypeSupplierInvoiceCredit', 'Supplier Invoice Credit'),
            [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE]: () => this.L('Document.TypeExpense', 'Expense'),
            [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE]: () => this.L('Document.TypeExpenseCreditNote', 'Expense Credit Note'),
            [constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER]: () => this.L('Document.TypePurchaseOrder', 'Purchase Order'),
        };
        if (typeStringMap[this.item.data.type]) {
            return typeStringMap[this.item.data.type]();
        }
        return '';
    }
    getIssueDate() {
        let issueDate;
        if (!this.item.data.taxpoint) {
            issueDate = this.item.data.dt_created;
        }
        else {
            issueDate = this.item.data.taxpoint;
        }
        //
        // try to parse issue date with handling old Node API response format bug
        //
        const pDate = (0, momentOverride_1.default)(issueDate.replace('T', ' ').replace('.000Z', ''));
        if (pDate) {
            issueDate = pDate.format('YYYY-MM-DD HH:mm:ss');
        }
        else {
            //
            // nope its still cannot to parse :(
            //
            console.log(`Can't parse ${issueDate}`);
        }
        return issueDate;
    }
    async getSite() {
        const job = await this.item.getJob();
        const jobSite = await job.getSite();
        const isWorkSheet = this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET;
        const displaySiteDetails = isWorkSheet && jobSite && jobSite.data.use_on_job_sheets;
        const defaultSite = await this.item.getDefaultSite();
        return displaySiteDetails ? jobSite : defaultSite;
    }
    async getFullName() {
        const customer = await this.item.getCustomer();
        const site = await this.getSite() || await customer.getMainSite();
        const contact = await site.getContact();
        return contact.getFullName();
    }
    async getSupplierData() {
        const parentDocument = await this.item.getParentDocument();
        if (this.item.data.is_disbursement && this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.INVOICE && parentDocument) {
            const supplier = (await parentDocument.getCustomer());
            return {
                fullName: await this.getFullName(),
                name: supplier.data.account_name,
            };
        }
        return undefined;
    }
    async getItemsData() {
        const documentItems = await this.item.getAllDocumentItem();
        return bluebird_1.default.map(documentItems.sort((a, b) => a.data.sequence - b.data.sequence), async (item) => {
            const linkedItem = await item.getLinkedItem();
            if (linkedItem && 'getDocumentRenderData' in linkedItem) {
                return linkedItem.getDocumentRenderData(this.L);
            }
            return undefined; // We can end up here e.g. when the linked_id is 0 for a DocumentItem, so lets filter any invalid DocumentItem out of results.
        }).filter(Boolean);
    }
    async getJobItems() {
        return this.item.getJobItems();
    }
    isCustomerPayReverseCharge(jobItem) {
        const isReverseCharge = [
            constants_1.TAX.TAX_RATES.REVERSE_STANDARD,
            constants_1.TAX.TAX_RATES.REVERSE_REDUCED,
        ].includes(jobItem.data.vat_id);
        return isReverseCharge && [
            constants_1.DOCUMENT.TYPES_VALUES.INVOICE,
            constants_1.DOCUMENT.TYPES_VALUES.QUOTE,
            constants_1.DOCUMENT.TYPES_VALUES.CREDITNOTE,
            constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE,
            constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT,
        ].includes(this.item.data.type);
    }
    getShowCustomerPayReverseCharge(jobItems) {
        let retValue = false;
        jobItems.forEach(jobItem => {
            if (jobItem.data.use_tax && this.isCustomerPayReverseCharge(jobItem)) {
                retValue = true;
            }
        });
        return retValue;
    }
    getDeliveryAddressTypeText(deliveryAddressType) {
        if (deliveryAddressType === constants_1.DELIVERY_ADDRESS.TYPE.BRANCH) {
            return this.L('DocumentView.BranchAddressLabel', 'Pick up from branch: ');
        }
        return '';
    }
    isSiteAddressHiddenByType(type) {
        return [constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET, constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER].includes(type);
    }
    async getDocumentTemplateData() {
        const company = await this.item.getCompany();
        const customer = await this.item.getCustomer();
        const typeString = await this.getDisplayTypeString();
        const customerData = await this.item.getCustomerContentData(this.L);
        const companyDataWithLogo = { ...await this.item.getCompanyContentData(this.L) };
        const supplierData = await this.getSupplierData();
        const items = await this.getItemsData();
        const jobItems = await this.getJobItems();
        let { quantityCanBeSupressed } = companyDataWithLogo;
        const { footerStyle } = companyDataWithLogo;
        if (!this.args.isPreview) {
            companyDataWithLogo.previewOnlyPageSize = '';
        }
        else {
            companyDataWithLogo.footerStyle = `position: absolute; bottom: 0;${footerStyle}`;
        }
        delete companyDataWithLogo.quantityCanBeSupressed;
        if (jobItems.find(item => item.data.quantity !== 1)) {
            quantityCanBeSupressed = false;
        }
        else {
            quantityCanBeSupressed = company.data.autoSupressQuantity;
        }
        const shouldShowSite = !(this.item.data.hide_site_address || this.isSiteAddressHiddenByType(this.item.data.type));
        let formattedSiteAddress = null;
        if (shouldShowSite) {
            formattedSiteAddress = customerData.formattedJobAddress;
        }
        const data = {
            shortTypeString: await this.getShortTypeString(),
            shallShowAccountName: this.shallShowAccountName(customer.data.is_supplier, customer.data.account_name),
            documentBodyPaddingStyle: await this.getDocBodyPaddingStyle(this.item.data.type),
            typeString,
            is_disbursement: this.item.data.is_disbursement,
            reminders_disabled: this.item.data.reminders_disabled,
            is_cis: this.item.data.is_cis,
            cis_total: this.item.data.cis_total,
            issuedate: this.getIssueDate(),
            displaynumber: this.item.data.displaynumber,
            supplierInvoice: this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE,
            customer: { ...customerData, customerTitle: await this.getCustomerTitle() },
            supplier: supplierData,
            formattedSiteAddress,
            showSiteAddress: Boolean(shouldShowSite && formattedSiteAddress),
            items,
            showTax: company.data.vat_registered,
            showInclusiveTaxLabel: company.data.tax_inclusive,
            showCustomerPayReverseCharge: this.getShowCustomerPayReverseCharge(jobItems),
            total: this.item.data.total,
            vat: this.item.data.vat,
            subtotal: this.item.data.subtotal,
            cis_estimate: this.item.data.cis_estimate,
            footer: this.item.data.footer,
            header: this.item.data.header,
            isExpense: Boolean(this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE || this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE),
            user: {
                fullName: this.args.fullName,
            },
            type: this.item.data.type,
            deliveryAddress: this.item.data.deliveryAddress,
            deliveryAddressType: this.item.data.deliveryAddressType,
            display_total: this.item.data.display_total,
            quantityCanBeSupressed,
            ...companyDataWithLogo,
            deliveryAddressTypeText: this.getDeliveryAddressTypeText(this.item.data.deliveryAddressType),
            showPaidStamp: this.item.data.type === constants_1.DOCUMENT.TYPES_VALUES.INVOICE && company.data?.companySettings?.enable_paid_stamp && ([constants_1.DOCUMENT.STATUS.PAID, constants_1.DOCUMENT.STATUS.OVER_PAID].includes(this.item.data.status)),
            isPreview: this.args.isPreview,
        };
        return data;
    }
}
exports.default = DocumentRenderData;
//# sourceMappingURL=../../../../src/models/document/renderData.js.map